// --- Node height (3D isometric view) ---
export const NODE_HEIGHT_MIN = 10;
export const NODE_HEIGHT_RANGE = 60;
export const NODE_HEIGHT_PERCENTAGE_CAP = 150;

// --- Heat-map status thresholds ---
export const THRESHOLD_GOOD = 90;
export const THRESHOLD_WARNING = 75;

// --- Node layout sizes ---
export const CAPABILITY_NODE_WIDTH = 400;
export const CAPABILITY_NODE_HEIGHT = 200;
export const TEAM_NODE_WIDTH = 500;
export const TEAM_NODE_HEIGHT = 200;
export const APP_GROUP_NODE_WIDTH = 400;
export const APP_GROUP_NODE_HEIGHT = 200;
export const LEAF_NODE_WIDTH = 200;
export const LEAF_NODE_HEIGHT = 65;
